__webpack_require__.p = "/mi-assets/mi-static/mi-awp-renderer/web-rel-26.7.1-d26f79e-12377/_next/";